module.exports = __webpack_public_path__ + "static/media/193.906a0a6a.jpg";